import type {
  AtLeast,
  LiteBlock,
  Repository,
} from '@basehub/data/replicache/index'
import type { TreeManager } from '@basehub/utils/tree/index'
// import { polishRepoPreviewURL } from '~/hooks-data/preview-link/helpers'

export const getOgBlockRootOptions = ({
  // repo,
  blockTreeManager,
}: {
  repo: AtLeast<Repository, 'previewUrl'>
  blockTreeManager: AtLeast<TreeManager<LiteBlock>, 'root'>
}) => {
  return [
    // {
    //   name: '_origin',
    //   value: polishRepoPreviewURL(repo.previewUrl) || '',
    //   node: null,
    // },
    {
      name: '_root',
      value: 'Root Block',
      node: blockTreeManager.root,
    },
  ]
}
